module.exports = __webpack_public_path__ + "img/Other.99f08c31.png";